import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import LoadingOverlay from 'components/LoadingOverlay';

export default function Page({
    children,
    isLoading
}) {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            {isLoading ?
                <div className={`fixed top-0 w-full overflow-y-auto bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                    <LoadingOverlay isLoading={isLoading} />
                </div>
                :
                <div className={`fixed top-0 w-full overflow-y-auto pb-20 bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                    {children}
                </div>

            }
        </>
    )
}
